import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

var _templateObject, _templateObject2;

import styled from 'styled-components';
import { font, spacing } from '@chegg-ui/theme';
import { getMediaQuery } from './common';
import { Link } from '@chegg-ui/link';
import React from 'react';
import { colors } from '@chegg-ui/theme';
export var Sup = styled.sup.withConfig({
  componentId: "sc-jpig5k-0"
})(["font-size:max(0.35em,11px);vertical-align:revert;border:transparent solid 1px;"]);
export var P = styled.p.withConfig({
  componentId: "sc-jpig5k-1"
})(["margin-bottom:", ";&:last-child{margin-bottom:0;}&:target{background-color:", ";}"], spacing.px16, colors.royalLight);
export var Sub = styled.sub.withConfig({
  componentId: "sc-jpig5k-2"
})(["vertical-align:sub;"]);
export var StyledAnchor = styled.a.withConfig({
  componentId: "sc-jpig5k-3"
})(["color:inherit;text-decoration:none;font-weight:normal;&:hover,:focus{text-decoration:underline;}"]);
export var StyledFullContentTitle = styled.h1.withConfig({
  componentId: "sc-jpig5k-4"
})(["", " font-weight:", ";text-align:left;", " ", ""], function (_ref) {
  var fontSize = _ref.fontSize,
      marginTop = _ref.marginTop;
  return "\n      font-size: ".concat(fontSize, ";\n      margin-top: ").concat(marginTop, ";\n    ");
}, font.weight.bold, getMediaQuery.md(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n        font-size: ", ";\n        text-align: center;\n    "])), font.size.px42), getMediaQuery.sm(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n        font-size: ", ";\n        margin-top: ", ";\n        text-align: center;\n    "])), font.size.px32, spacing.px32));
export var StyledDisclaimerAnchor = styled(StyledAnchor).withConfig({
  componentId: "sc-jpig5k-5"
})(["display:inline;"]);
export var StyledDescriptionLink = styled(Link).withConfig({
  componentId: "sc-jpig5k-6"
})(["font:inherit;"]);
export var StyledLink = function StyledLink(link, children) {
  return /*#__PURE__*/React.createElement(StyledDescriptionLink, {
    href: link
  }, children);
};
export var getExistingSegment = function getExistingSegment(index) {
  var SEGMENT_STRING = 'abcdefghijklmnopqrstuvwxyz';
  return SEGMENT_STRING[index];
};
/**
 * return an array with parts of string replaced with React components.
 * @param textSegment the string with parts to be replaced
 * @param regex the regular expression to find the matches to be replaced
 * @param renderer function that returns the react component with which the match needs to be replaced.
 * @returns an array of react nodes.
 * Given an input string, would replace every substring that is matched by the `regex`
 * with the result of calling `renderer` on matched substring. The result will be an
 * array with all odd indexed elements containing the replacements.
 *
 * Example:
 * stringToReactNodes(
 *   'Replaces all the * with superscript *',
 *   /(*)/,
 *   (segment, index) => <sup key={index}>{segment}</sup>
 * );
 * // => ['Replaces all the', <sup>*</sup>, ' with superscript ', <sup>*</sup>]
 */

export var stringToReactNodes = function stringToReactNodes(textSegment, regex, renderer, sharedData) {
  if (!regex.test(textSegment)) {
    return [textSegment];
  } // The matches would be odd indexed elements hence running the `renderer` only for them.


  var splitString = textSegment.split(regex); // @TODO investigate if disclaimerParser logic can be moved to BFF

  var disclaimerSegment = splitString[1];
  var existingSegment = '';

  if (sharedData.disclaimer) {
    var disclaimer = sharedData.disclaimer;

    if (disclaimer[disclaimerSegment]) {
      existingSegment = getExistingSegment(disclaimer[disclaimerSegment].length);
      disclaimer[disclaimerSegment].push(disclaimerSegment);
    } else {
      existingSegment = getExistingSegment(0);
      disclaimer[disclaimerSegment] = [disclaimerSegment];
    }
  }

  return splitString.map(function (segment, index) {
    if (index % 2 === 0) {
      return segment;
    }

    return renderer(segment, index, existingSegment);
  });
};
export var disclaimerParser = function disclaimerParser(textSegment, sharedData) {
  var DisclaimerRender = function DisclaimerRender(segment, index, existingSegment) {
    return /*#__PURE__*/React.createElement(Sup, {
      key: index
    }, /^\*/.test(segment) ? /*#__PURE__*/React.createElement(React.Fragment, null, segment.substring(1)) : /*#__PURE__*/React.createElement(StyledDisclaimerAnchor, {
      id: "disclaimer-".concat(segment, "-").concat(segment.length).concat(existingSegment ? "-".concat(existingSegment) : ''),
      href: "#disclaimer-".concat(segment).concat(existingSegment ? "-".concat(existingSegment) : ''),
      key: "segment-".concat(index)
    }, segment));
  };

  return stringToReactNodes(textSegment, /\{(\d+|\*.+)\}/, DisclaimerRender, sharedData);
};
export var RenderFullContentTitle = function RenderFullContentTitle(children) {
  var as = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'h2';
  return /*#__PURE__*/React.createElement(StyledFullContentTitle, {
    fontSize: spacing.px48,
    marginTop: "3.25rem",
    as: as
  }, children);
};